import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    default: String
  };

  static targets = ['input', 'dialog'];

  connect() {
    const controller = this;

    this.dialogModal = $(this.dialogTarget).dialog({
      autoOpen: false,
      dialogClass: 'json-structure-reset-confirm',
      resizable: false,
      draggable: false,
      modal: true,
      title: 'Restore Default Structured Data',
      buttons: {
        Cancel: function () {
          $(this).dialog('close');
        },
        Reset: function () {
          $(this).dialog('close');
          $(controller.inputTarget).val(controller.defaultValue).trigger('change');
        }
      }
    });

    $(this.dialogModal).children("p").text(`
        Are you sure you want to restore default structured data?
        This will remove all customizations and revert to the original settings
      `
    );
  }

  reset() {
    if (this.inputTarget.value.trim()) {
      $(this.dialogModal).dialog('open');
    } else {
      $(this.inputTarget).val(this.defaultValue).trigger('change');
    }
  }
}
